import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_ranked_badges';

// Example set of params for the query
/*
{
    "listingId": "321.887611.1435551"
}
 */

const rankedBadgesQuery = `
    query rankedBadges($listingId : String!) {
        rankedBadges(listingTriad : $listingId, rankingStrategy: PDP) {
            id
            name
        }
    }
`;

async function rankedBadgesGraphQl({listingId, locale}) {
    return await graphqlQuery(OPERATION_NAME, rankedBadgesQuery, {listingId}, locale);
}

export default rankedBadgesGraphQl;
export {OPERATION_NAME, rankedBadgesGraphQl, rankedBadgesQuery};
